import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { CoreMenuItem } from '@core/types';
import { SocketIoService } from 'app/main/services/io.service';
import { WhatsappNotificationService } from 'app/main/services/whatsapp-notification.service';
import { WEBSOCKET_EVENT } from 'app/main/shared/enums/WebsocketEvent.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: '[core-menu-vertical-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent implements OnInit, OnDestroy {
  @Input()
  item: CoreMenuItem;

  private _unsubscribeAll: Subject<any>;
  public hasArchiveNotification: boolean;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private readonly _socket: SocketIoService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    if (this.item.data?.hasNotifications) {
      this._socket
      .listen(WEBSOCKET_EVENT.FILE_NOTIFICATION)
      .subscribe((objeto: any) => {
        this.hasArchiveNotification = true;
        this._changeDetectorRef.detectChanges();
      });
    }

  }


  deleteArchiveNotification() {
    if (this.hasArchiveNotification) {
      this.hasArchiveNotification = false;
      this._changeDetectorRef.detectChanges();
    }
  }
  
  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
